import { render, staticRenderFns } from "./signup.vue?vue&type=template&id=272008ba&scoped=true"
import script from "./signup.vue?vue&type=script&lang=js"
export * from "./signup.vue?vue&type=script&lang=js"
import style0 from "./signup.vue?vue&type=style&index=0&id=272008ba&prod&lang=scss"
import style1 from "./signup.vue?vue&type=style&index=1&id=272008ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272008ba",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VTextField: require('/app/node_modules/vuetify/lib/components/VTextField/VTextField.js').default,VRadio: require('/app/node_modules/vuetify/lib/components/VRadioGroup/VRadio.js').default,VRadioGroup: require('/app/node_modules/vuetify/lib/components/VRadioGroup/VRadioGroup.js').default,VTooltip: require('/app/node_modules/vuetify/lib/components/VTooltip/VTooltip.js').default,CBtn: require('/app/components/ui/button/c-btn.vue').default,VForm: require('/app/node_modules/vuetify/lib/components/VForm/VForm.js').default})


/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VForm,VRadio,VRadioGroup,VTextField,VTooltip})
